import {
  ParagraphText,
  StackLayout,
  TextAction,
  UtilityText,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import { useExternalLinks } from 'hooks/use-external-links/use-external-links.hook';

const DisclaimerLinkWrapper = (href: string) => (text: React.ReactNode) =>
  (
    <TextAction
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      css={{ typography: '$caption', display: 'inline' }}
    >
      {text}
    </TextAction>
  );

const DisclaimerLinkText = () => {
  const { formatMessage } = useIntl();
  const externalLinks = useExternalLinks();

  return (
    <ParagraphText css={{ typography: '$caption', display: 'inline' }}>
      {formatMessage(
        { id: 'STR_FOOTER_DISCLAIMER_FULL_LINK' },
        {
          privacyLink: DisclaimerLinkWrapper(
            externalLinks.PRIVACY_POLICY ||
              externalLinks.PRIVACY_COLLECTION_NOTICE,
          ),
          termsLink: DisclaimerLinkWrapper(externalLinks.TERMS_OF_SERVICE),
        },
      )}
    </ParagraphText>
  );
};

export const Disclaimer = () => {
  const { formatMessage, messages } = useIntl();
  const year = new Date().getFullYear();

  const disclaimerText = formatMessage(
    { id: 'STR_FOOTER_DISCLAIMER' },
    { year },
  );
  const copyrightText = formatMessage({ id: 'STR_FOOTER_COPYRIGHT' }, { year });

  return (
    <StackLayout spacing="$oneAndHalf">
      <StackLayout spacing="$half" css={{ width: '100%' }}>
        <UtilityText as="p" css={{ typography: '$caption', display: 'inline' }}>
          {disclaimerText}
        </UtilityText>
        {!!messages.STR_FOOTER_DISCLAIMER_FULL_LINK && <DisclaimerLinkText />}
      </StackLayout>

      <ParagraphText css={{ typography: '$caption', fontWeight: '500' }}>
        {copyrightText}
      </ParagraphText>
    </StackLayout>
  );
};
